import { defineComponent } from "vue";
import { EventBus } from "@/utils/event-bus";
import { getCookie } from "@/utils/cookie";

export default defineComponent({
  name: "pg-dashboard",
  components: {
    logo: () => import("@/assets/flow-modeler-logo.vue"),
    "sdk-profile-card-mini": () => import("@/components/sdk-ui/sdk-profile-card-mini/sdk-profile-card-mini.vue"),
    "sdk-menu": () => import("@/components/sdk-ui/sdk-menu/sdk-menu.vue"),
    "sdk-system-info": () => import("@/components/sdk-ui/sdk-system-info/sdk-system-info.vue"),
  },
  data() {
    return {
      mouseEnter: false,
      isCollapse: false,
      versionSdk: "",
      isDialogShown: false,
      selectedLanguage: "",
      languages: [
        { text: "Português (BR)", value: "pt_BR" },
        { text: "Espãnol (CL)", value: "es_CL" },
        { text: "Espãnol (DO)", value: "es_DO" },
        { text: "Espãnol (EC)", value: "es_EC" },
        { text: "Espãnol (ES)", value: "es_ES" },
        { text: "Espãnol (MX)", value: "es_MX" },
        { text: "Espãnol (PA)", value: "es_PA" },
        { text: "Espãnol (PE)", value: "es_PE" },
        { text: "Espãnol (UY)", value: "es_UY" },
      ],
    };
  },
  methods: {
    show() {
      this.isDialogShown = true;
    },
    close() {
      this.isDialogShown = false;
    },
    changeLanguage() {
      this.$i18n.locale = this.selectedLanguage;
      document.cookie = "language =" + this.selectedLanguage;
      // localStorage.setItem('systemLanguage', this.selectedLanguage);
      window.location.reload();
      this.close();
    },
    toggleMenu(state: boolean) {
      this.mouseEnter = state;
      if (state) {
        setTimeout(() => {
          if (this.mouseEnter) {
            EventBus.$emit("is-dashboard-open", this.isCollapse);
            this.isCollapse = false;
          }
        }, 600);
      } else {
        EventBus.$emit("is-dashboard-open", this.isCollapse);
        this.isCollapse = true;
      }
    },
  },
  async mounted() {
    const language = getCookie("language");
    if (!language) {
      this.$i18n.locale = `${navigator.language.substring(0, 2)}_${navigator.language.substring(3, 5)}`;
      document.cookie = `language = ${this.$i18n.locale}`;
    }
    this.selectedLanguage = this.$i18n.locale;

    EventBus.$on("open-language-dialog", () => {
      this.show();
    });
  },
  beforeDestroy() {
    EventBus.$off("is-dashboard-open");
    EventBus.$off("open-language-dialog");
  },
});
